import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const createTicketRBAC = {
  pageID: '69b469fbd162144e95179ff81defad22',
  elementID: {
    ViewPage: 'a6a8db67e7d7acad10330b35d2a51603',
    SubmitTicket: 'b43ba2a4cacbfb63f801a81fc5414bf3',
  },
} as const

export const useRBACCreateTicketPage = createUseRBAC(createTicketRBAC.elementID)
export type UseRBACCreateTicketPageType = ReturnType<typeof useRBACCreateTicketPage>
